<script>
  import QuestionFrame from './QuestionFrame.svelte';
</script>

<QuestionFrame>
  <p>
    Haben Sie funktionelle Störungen der Beckenorgane?<br />
    Zum Beispiel eine oder mehrere der folgenden:
  </p>
  <ul class="list-disc ml-6">
    <li>häufigen Harndrang, Brennen beim Wasserlassen</li>
    <li>abgeschwächter Harnstrahl und verzögerter Beginn beim Urinieren (vor allem bei Männern)</li>
    <li>Stuhlunregelmäßigkeiten (oft Wechsel von Verstopfung und Durchfall)</li>
    <li>Probleme beim Geschlechtsverkehr (z.B. mangelnde Erektion, enge Scheide)</li>
    <li>
      Das Gefühl, Blase oder Darm seien nach dem Wasserlassen oder Stuhlgang nicht ganz entleert
    </li>
  </ul>
</QuestionFrame>
